
export const requiredField = ( constrain: boolean ): string => constrain ? 'Campo requerido.' : ''